export const fitWidth = (
    pageWidth: number,
    containerInnerWidth: number,
): number => {
    if (pageWidth >= containerInnerWidth) {
        return Number((containerInnerWidth / pageWidth).toFixed(2));
    }

    // Calculate the diff here to get the rounded down number
    return 1 + (1 - Number((pageWidth / containerInnerWidth).toFixed(2)));
};

export default {};
